<script>
import { defineComponent } from '@vue/composition-api'

export default defineComponent({
  setup() {
    
  },
  name: 'CardImage',
  props: {
    src: String
  }
})
</script>

<style scoped>
img {
  width: 100%;
  height: 300px;
  object-fit: cover;
  border-top-right-radius: 5px;
  border-top-left-radius: 5px;
}

@media screen and (max-width: 768px) {
  img {
    height: 225px;
  }
}
</style>

<template>
  <img :src="src" v-bind="$attrs" />
</template>
